exports.APP_VERSION = "0.5.2";
